/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */

export enum UserSignInStep {
	Create = 'create',
	Confirm = 'confirm',
}

export enum Theme {
	Light = 'light',
	Dark = 'dark',
}

export enum Lang {
	Gl = 'gl',
	Es = 'es',
	En = 'en',
}

export enum UserLoginType {
	Normal = 'normal',
	Anonymous = 'anonymous',
}

export enum UserResetPswStep {
	One = 'one',
	Two = 'two',
	Three = 'three',
}

export enum GameLoginType {
	Private = 'private',
	Public = 'public',
}

export enum TokenType {
	UserToken = 'user-token',
	GameToken = 'game-token',
	PlayerToken = 'player-token',
}

export enum ValidationMode {
	Existing = 'existing',
	New = 'new',
}

export enum UserValidationType {
	Name = 'name',
	Email = 'email',
}

export enum PlayersAmount {
	Two = 2,
	Three = 3,
	Five = 5,
	Seven = 7,
}

export enum PhaseKind {
	Soups = 'soups',
	Memory = 'memory',
	Bagels = 'bagels',
	Song = 'song',
}

export enum Team {
	Blue = 'blue',
	Orange = 'orange',
}

export enum MemoryGridStatus {
	None = 'none',
	Preview = 'preview',
	ReadyForPlaying = 'readyForPlaying',
}

export enum MemoryPhaseIndex {
	One = 1,
	Two = 2,
	Three = 3,
	Four = 4,
	Five = 5,
	Six = 6,
	Seven = 7,
	Eight = 8,
	Nine = 9,
}

export enum SongClueType {
	Year = 'year',
	SongPiece = 'songPiece',
	Lyric = 'lyric',
	DisorderedTitle = 'disorderedTitle',
	TranslatedTile = 'translatedTile',
	SynonimTitle = 'synonimTitle',
}

export enum SongClueStatus {
	None = 'none',
	Playing = 'playing',
	ReadyForAnswer = 'readyForAnswer',
	Rebounded = 'rebounded',
	Answered = 'answered',
}

export enum BagelQuestionStatus {
	None = 'none',
	Hit = 'hit',
	Miss = 'miss',
	Pass = 'pass',
}

export enum AlphabetSoupAnswerStatus {
	None = 'none',
	Hit = 'hit',
}

export enum PlayerRole {
	Player1 = 'player1',
	Player2 = 'player2',
	Presenter = 'presenter',
	PlayerPresenter = 'playerPresenter',
	Guest = 'guest',
}

export enum GameType {
	Public = 'public',
	Private = 'private',
	All = 'all',
}

export enum UpdatePlayerType {
	Pick = 'pick',
	Release = 'release',
	Ready = 'ready',
}

export enum BagelPhaseV3RequestType {
	Fix = 'fix',
	Update = 'update',
}

export enum BagelQuestionRequestType {
	Update = 'update',
	Fix = 'fix',
}

export enum UpdateMemoryGridRequestType {
	Toggle = 'toggle',
	Flip = 'flip',
	Fix = 'fix',
}

export enum UpdateSongClueRequestType {
	StatusChange = 'statusChange',
	Answer = 'answer',
	ObtainTurn = 'obtainTurn',
}

export enum SongClueAnswerType {
	Hit = 'hit',
	Miss = 'miss',
}

export enum UpdateAlphabetSoupRequestType {
	Rebound = 'rebound',
	Fix = 'fix',
}
